import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
   MapContainer,
   TileLayer,
   useMap,
   Marker,
   Popup,
   Tooltip,
   SVGOverlay,
   CircleMarker,
   useMapEvent,
} from "react-leaflet";

import KarteObjekte from "./KarteObjekte";
import GetGeoCoords from "./GetGeoCoords";
import KarteTermine from "./KarteTermine";


export default function NutzerauswertungZweiKarten({
   terminInfos,
   userObjects,
   estates,
   selectedUser,
   setSelectedUser,
   center,
   setCenter,
   centerPin,
   terminArten,
   getUserCalendar
}) {
   const [mapTermin, setMapTermin] = useState();
   const [mapObjekte, setMapObjekte] = useState();
   const [searchCoords, setSearchCoords] = useState();

   const onMoveMapTermin = useCallback(() => {
      mapObjekte.setView(mapTermin.getCenter(), mapTermin.getZoom());
   }, [mapTermin, mapObjekte]);
   /*    const onMoveMapObjekte = useCallback(() => {
      mapTermin.setView(mapObjekte.getCenter(), mapObjekte.getZoom());
   }, [mapTermin, mapObjekte]); */

   useEffect(() => {
      if (mapObjekte && mapTermin) {
         mapTermin.on("move", onMoveMapTermin);
         return () => {
            mapTermin.off("move", onMoveMapTermin);
         };
      }
   }, [mapTermin, mapObjekte, onMoveMapTermin]);

   useEffect(() => {
      if (mapTermin && mapObjekte && searchCoords) {
         mapTermin.setView([searchCoords.lat, searchCoords.lon], 13);
         mapObjekte.setView([searchCoords.lat, searchCoords.lon], 13);
      }
   }, [mapTermin, mapObjekte, searchCoords]);

   
   useEffect(() => {
      if (mapTermin && mapObjekte && centerPin) {
         mapTermin.setView(centerPin, 11);
         mapObjekte.setView(centerPin, 11);
      }
   }, [mapTermin, mapObjekte, centerPin]);

   return (
      <>
         {" "}
         <GetGeoCoords searchCoords={searchCoords} setSearchCoords={setSearchCoords} />
         <div className="flex-row">
            <KarteObjekte
               myMap={mapTermin}
               setMyMap={setMapTermin}
               frameStyle={{position: "relative", width: "50%", borderRadius: "12px", height: "50vh", margin: "4px 6px" }}
               center={center}
               setCenter={setCenter}
               estates={estates}
               userObjects={userObjects}
               selectedUser={selectedUser}
               setSelectedUser={setSelectedUser}
               searchCoords={searchCoords}
               centerPin={centerPin}
            />
            <KarteTermine
               terminInfos={terminInfos}
               userObjects={userObjects}
               terminArten={terminArten}
               center={center}
               setCenter={setCenter}
               myMap={mapObjekte}
               setMyMap={setMapObjekte}
               frameStyle={{position: "relative", width: "50%", borderRadius: "12px", height: "50vh", margin: "4px 6px" }}
               searchCoords={searchCoords}
               centerPin={centerPin}
               getUserCalendar={getUserCalendar}
            />
         </div>
      </>
   );
}
